import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DialogModule } from 'primeng/dialog'
import { ButtonModule } from 'primeng/button'

@Component({
  selector: 'app-event-details-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './event-details-modal.component.html',
  styleUrl: './event-details-modal.component.scss',
})
export class EventDetailsModalComponent {
  /**
   * Contrôle la visibilité de la modale
   */
  @Input() visible: boolean = false

  /**
   * Événement émis quand la visibilité change
   */
  @Output() visibleChange = new EventEmitter<boolean>()

  /**
   * Les détails de l'événement sélectionné
   */
  @Input() eventDetails: any = null

  /**
   * Ferme la modale
   */
  close(): void {
    this.visible = false
    this.visibleChange.emit(false)
  }
}
